import { ListeningState } from '@models/listening';
import { UPDATE_ACTION } from '.';

export const setScore = (correctAnswers: number) => ({
  type: UPDATE_ACTION,
  payload: {
    correctAnswers: correctAnswers,
  },
});

export const getInitialReviewListeningState = (totalOfQuestions: number): ListeningState => ({
  //buttons
  isNextButtonVisible: true,
  correctAnswers: 0,

  //elemets
  isProgressBarVisible: true,
  isTypeOfExamenVisble: false,
  isReviewButtonVisible: false,
  isTagVisible: true,
  isTimerVisible: false,
  isTimeRunning: false,

  //values
  tag: 'lisening',
  progressValue: 100,
  questionIndex: 0,
  minutes: 0,
  seconds: 0,
  totalOfQuestions: totalOfQuestions,
});

export const getInitialListeningScoreState = (
  correctAnswers: number,
  totalOfQuestions: number
): ListeningState => ({
  //buttons
  isNextButtonVisible: false,
  correctAnswers: correctAnswers,

  //elemets
  isProgressBarVisible: true,
  isTypeOfExamenVisble: false,
  isReviewButtonVisible: true,
  isTagVisible: false,
  isTimerVisible: false,
  isTimeRunning: false,

  //values
  tag: 'reading',
  progressValue: 100,
  questionIndex: 0,
  minutes: 0,
  seconds: 0,
  totalOfQuestions: totalOfQuestions,
});

export const getInitialListeningState = (
  totalQuestions: number,
  minutes: number,
  seconds: number
): ListeningState => ({
  //buttons
  isNextButtonVisible: true,
  isTypeOfExamenVisble: false,

  //elemnts
  isProgressBarVisible: true,
  isReviewButtonVisible: false,
  isTimerVisible: true,
  isTimeRunning: true,
  isTagVisible: true,

  //values
  tag: 'Listening',
  minutes: minutes,
  seconds: seconds,
  questionIndex: 0,
  progressValue: 0,
  totalOfQuestions: totalQuestions,
  correctAnswers: 0,
});

export const getInitialListeningWelcomeState = (): ListeningState => ({
  //buttons
  isNextButtonVisible: true,
  isTypeOfExamenVisble: false,

  //elemets
  isReviewButtonVisible: false,
  isProgressBarVisible: true,
  isTimerVisible: false,
  isTimeRunning: false,
  isTagVisible: true,

  //values
  tag: 'listening',
  minutes: 0,
  seconds: 0,
  progressValue: 0,
  questionIndex: 0,
  totalOfQuestions: 0,
  correctAnswers: 0,
});

export function listeningReducer(
  state: ListeningState,
  action: { type: string; payload: Partial<ListeningState> }
) {
  switch (action.type) {
    case UPDATE_ACTION:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
